import PaginatedResponse from '../base/paginatedResponse'
import { Field, Int, ObjectType } from '@nestjs/graphql'
import { UserNotificationDto } from './userNotification.dto'

@ObjectType()
export class UserNotificationPagedResultDto extends PaginatedResponse(UserNotificationDto) {
  @Field(t => Int)
  unreadNotificationCount!: number
}
